var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/libp2p-webrtc-star/~/isarray/index.js
// module id = 652
// module chunks = 0